function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
/* eslint-disable
    prettier/prettier
*/ // TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
// modern-bundle! import Backbone from 'backbone'
// modern-bundle! import template from 'js/core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal'
// modern-bundle! const JST = {
// modern-bundle!   'core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal': template,
// modern-bundle! };
// modern-bundle! import _ from 'lodash'
class ConfirmModal extends Backbone.View {
  static initClass() {
    this.prototype.template = 'core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal';
    this.prototype.events = {
      'click .js-confirm-modal-confirm-button': '_confirmClicked',
      'click .js-confirm-modal-cancel-button': '_cancelClicked'
    };
  }
  initialize(options) {
    this.options = options;
    this.successCallback = this.options.successCallback;
    this.render();
    this.$el.appendTo('body');
    this.ui = {
      $modal: this.$('.confirm-modal')
    };
    const ui = this.ui.$modal // When modal is dismissed, cleanup this view
    .on('hidden.bs.modal', () => this.remove());
    // TODO (Zanchi): Might not be necessary
    typeof ui.modal === 'function' && ui.modal('show');
    return this;
  }
  render() {
    this.$el.append(JST[this.template](this.viewOptions()));
    return this;
  }
  _confirmClicked() {
    this.ui.$modal.modal('hide');
    if (typeof this.successCallback === 'function') {
      this.successCallback();
    }
    return this.trigger('confirm');
  }
  _cancelClicked() {
    return this.trigger('cancel');
  }
  remove() {
    this.trigger('close');
    return super.remove();
  }
  viewOptions() {
    const passedInOptions = _.pick(this.options, ['successCallback', 'mainText', 'subText', 'cancelButtonText', 'confirmButtonText', 'confirmButtonClasses']);
    const defaultOptions = {
      confirmButtonClasses: 'btn-danger'
    };
    return _object_spread({}, defaultOptions, passedInOptions);
  }
}
ConfirmModal.initClass();
window.ConfirmModal = ConfirmModal; // modern-bundle! export default ConfirmModal
window._define_property = _define_property;
window._object_spread = _object_spread;
window.ConfirmModal = ConfirmModal;